/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

export { OpenTelemetryTransportV3 } from './OpenTelemetryTransportV3';
